// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dlpro-container-loading{
	    display: flex;
    justify-content: center;
    height: 100vh;
    align-items: center;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Loading.css"],"names":[],"mappings":"AAAA;KACK,aAAa;IACd,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":[".dlpro-container-loading{\r\n\t    display: flex;\r\n    justify-content: center;\r\n    height: 100vh;\r\n    align-items: center;\r\n}\r\n@media screen and (max-width: 50em) {\r\n  .Logo2bad-login{\r\n\twidth: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
